// @ts-check
import {
  StyledMonteCarloSimulation,
  StyledDescription,
  StyledHeader,
  StyledTypeViewWrapper
} from './MonteCarloSimulation.style';
import ViewTypeSelector, {
  FORECAST_VIEW_TYPES
} from './ViewTypeSelector/ViewTypeSelector';
import ColumnChart from './ColumnChart/ColumnChart';
import CalendarView from './CalendarView';
import useViewType from './useViewType';
import useColumnChartType from './ColumnChart/useChartType';

const MonteCarloSimulation = ({ forecast }) => {
  const viewType = useViewType();
  const columnChartType = useColumnChartType();

  return (
    <StyledMonteCarloSimulation>
      <StyledHeader>Monte Carlo Simulation</StyledHeader>
      <StyledDescription>
        Monte Carlo prediction module for project completion uses statistical
        simulations <br />
        to estimate the probability of meeting project deadlines by analyzing
        <br />
        multiple potential outcomes based on historical data and variability in
        task durations.
      </StyledDescription>
      <ViewTypeSelector value={viewType.value} onChange={viewType.onChange} />
      <StyledTypeViewWrapper>
        {viewType.value === FORECAST_VIEW_TYPES.COLUMN_CHART && (
          <ColumnChart forecast={forecast} chartType={columnChartType} />
        )}
        {viewType.value === FORECAST_VIEW_TYPES.CALENDAR && (
          <CalendarView forecast={forecast} />
        )}
      </StyledTypeViewWrapper>
    </StyledMonteCarloSimulation>
  );
};

export default MonteCarloSimulation;
